export default __webpack_public_path__ + "static/media/Role_po.4e0c66cc.png";